'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * Editable label
 *
 * @TODO: Functionality is not implemented; it is purely cosmetic at this point.
 */
var EditableLabel = react.forwardRef(function (props, ref) {
  var styles = react.useStyles();
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.span, _extends__default["default"]({
    ref: ref,
    __css: styles.label,
    className: utils.cx('chakra-editable__label', props.className)
  }, props));
});
EditableLabel.displayName = 'EditableLabel';
exports.EditableLabel = EditableLabel;